import { render, staticRenderFns } from "./AvatarView.vue?vue&type=template&id=721a9fa4&"
import script from "./AvatarView.vue?vue&type=script&lang=js&"
export * from "./AvatarView.vue?vue&type=script&lang=js&"
import style0 from "./AvatarView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports